export default __webpack_public_path__ + "static/media/pocketEbook.71e7b45f.png";